module.exports = __webpack_public_path__ + "img/mulish-v11-latin-800.c13e492.svg";